export const getPlaceholder = (type: string) => {
  if (type === 'org') {
    return '/images/generic_placeholders/placeholder_organization.png'
  }
  if (type === 'sched') {
    return '/images/generic_placeholders/placeholder_competition.png'
  }
  return '/images/generic_placeholders/placeholder_team.png'
}

export const formatDateRange = (startsAt: string, endsAt: string): string => {
  const startDate = new Date(startsAt)
  const endDate = new Date(endsAt)
  const now = new Date()
  const fmt = (d: Date) =>
    d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: d.getFullYear() !== now.getFullYear() ? 'numeric' : undefined,
    })
  const range = `${fmt(startDate)} - ${fmt(endDate)}`
  return endDate < now ? `${range} (Ended)` : range
}
